
import styles from "../views/pages/PaymentForm.module.css"

const NetworkOption = ({id, name, desc, color, icon, setCryptoNetwork}) => {
  
    return (<div className={styles.networkOption}>
                        <input type="radio" id={id} name="crypto-network" value={id} onChange={() => setCryptoNetwork(id)}/>
                        <label htmlFor={id}>
                            <div className={styles.networkInfo}>
                                <div className={styles.networkIcon} style={{backgroundColor: color}}>
                                    ${icon}
                                </div>
                                <div className={styles.networkDetails}>
                                    <div className={styles.networkName}>{name}</div>
                                    <div className={styles.networkDesc}>{desc}</div>
                                </div>
                            </div>

                        </label>
                    </div>)
}
export default NetworkOption